import { render, staticRenderFns } from "./WallpapersView.vue?vue&type=template&id=39164286&scoped=true"
import script from "./WallpapersView.vue?vue&type=script&lang=js"
export * from "./WallpapersView.vue?vue&type=script&lang=js"
import style0 from "./WallpapersView.vue?vue&type=style&index=0&id=39164286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39164286",
  null
  
)

export default component.exports